<template>
  <section class="bg-background-neutral-secondary space-y-4 rounded-2xl p-4">
    <!-- TODO: Use FreeFormInput and FreeFormSegment -->
    <div class="space-y-4">
      <FreeInput
        v-maska:[inputsMasks.initials]
        :model-value="passenger.lastName"
        :label="t('lastName')"
        :has-error="validations.lastName.$error"
        placeholder="MURATOV"
        @maska="updatePassenger({ lastName: $event.detail.masked })"
      >
        <template #errorMessage>
          {{ validations.lastName.$errors[0].$message }}
        </template>
        <template #clearButton>
          <FreeCloseButton class="clear-input-button" />
        </template>
      </FreeInput>
      <FreeInput
        v-maska:[inputsMasks.initials]
        :model-value="passenger.firstName"
        :label="t('firstName')"
        :has-error="validations.firstName.$error"
        placeholder="ALIM"
        @maska="updatePassenger({ firstName: $event.detail.masked })"
      >
        <template #errorMessage>
          {{ validations.firstName.$errors[0].$message }}
        </template>
        <template #clearButton>
          <FreeCloseButton class="clear-input-button" />
        </template>
      </FreeInput>
      <div class="space-y-2">
        <p class="text-text-neutral-tertiary text-xs font-medium">
          {{ t('gender.label') }}
        </p>
        <FreeSegmentControl
          :active-id="passenger.gender"
          :class="{
            'border-background-negative-accent border':
              validations.gender.$error,
          }"
        >
          <FreeSegment
            id="F"
            name="Female"
            @onChange="updatePassenger({ gender: 'F' })"
          >
            {{ t('gender.female') }}
          </FreeSegment>
          <FreeSegment
            id="M"
            name="Male"
            @onChange="updatePassenger({ gender: 'M' })"
          >
            {{ t('gender.male') }}
          </FreeSegment>
        </FreeSegmentControl>
        <p
          v-if="validations.gender.$error"
          class="text-text-negative-primary text-xs"
        >
          {{ validations.gender.$errors[0].$message }}
        </p>
      </div>
      <FreeInput
        v-maska:[inputsMasks.date]
        type="tel"
        :model-value="passenger.dob"
        :label="t('dateOfBirth')"
        :has-error="validations.dob.$error"
        :placeholder="t('datePlaceholder')"
        @maska="updatePassenger({ dob: $event.detail.masked })"
      >
        <template #errorMessage>
          {{ validations.dob.$errors[0].$message }}
        </template>
        <template #clearButton>
          <FreeCloseButton class="clear-input-button" />
        </template>
      </FreeInput>
      <div class="space-y-3">
        <span class="text-text-neutral-tertiary text-xs font-medium">
          {{ t('citizenship') }}
        </span>
        <button
          type="button"
          class="text-text-neutral-tertiary bg-situational-lightgrey h-13 flex w-full items-center justify-between rounded-2xl px-4"
          @click="openCitizenshipBottomSheet"
        >
          <span
            class="text-text-neutral-primary truncate text-left text-base font-normal"
          >
            {{ citizenshipText }}
          </span>
          <img
            src="../../../assets/images/chevron-arrow.svg"
            width="24"
            height="24"
            alt=""
          />
        </button>
      </div>
      <FreeInput
        v-maska:[inputsMasks.documentNumber]
        :model-value="passenger.document.number"
        :has-error="validations.document.number.$error"
        :placeholder="t(`${documentNumberI18nBase}.placeholder`)"
        @maska="updateDocument({ number: $event.detail.masked })"
      >
        <template #label>
          <div class="flex items-center justify-between">
            <p>{{ t(`${documentNumberI18nBase}.label`) }}</p>
            <button
              type="button"
              class="px-1"
              @click="openDocumentsBottomSheet"
            >
              <img
                src="../../../assets/images/note.svg"
                width="20"
                height="20"
                alt="Открыть подробную информацию о номере документа"
              />
            </button>
          </div>
        </template>
        <template #errorMessage>
          {{ validations.document.number.$errors[0].$message }}
        </template>
        <template #clearButton>
          <FreeCloseButton class="clear-input-button" />
        </template>
      </FreeInput>
      <FreeInput
        v-if="isIinVisible"
        v-maska:[inputsMasks.iin]
        type="tel"
        :model-value="passenger.iin"
        :label="t('iin')"
        :has-error="validations.iin.$error"
        placeholder="000000000000"
        @maska="updatePassenger({ iin: $event.detail.masked })"
      >
        <template #errorMessage>
          {{ validations.iin.$errors[0].$message }}
        </template>
        <template #clearButton>
          <FreeCloseButton class="clear-input-button" />
        </template>
      </FreeInput>
      <FreeInput
        v-if="isFinVisible && providerClassLib.isFunSun(providerClass)"
        v-maska:[inputsMasks.fin]
        :model-value="passenger.fin"
        :label="t('fin')"
        :has-error="validations.fin.$error"
        placeholder="A1BB2C3"
        @maska="updatePassenger({ fin: $event.detail.masked })"
      >
        <template #errorMessage>
          {{ validations.fin.$errors[0].$message }}
        </template>
        <template #clearButton>
          <FreeCloseButton class="clear-input-button" />
        </template>
      </FreeInput>
      <div
        v-if="isSeriesVisible && providerClassLib.isFunSun(providerClass)"
        class="space-y-2"
      >
        <FreeInput
          v-maska:[inputsMasks.series]
          :model-value="passenger.document.series"
          :has-error="validations.document.series.$error"
          :placeholder="t('series.placeholder')"
          @maska="updateDocument({ series: $event.detail.masked })"
        >
          <template #label>
            <div class="flex items-center justify-between">
              <p>{{ t('series.label') }}</p>
              <button
                type="button"
                class="px-1"
                @click="openDocumentSeriesBottomSheet"
              >
                <img
                  src="../../../assets/images/note.svg"
                  width="20"
                  height="20"
                  alt="Открыть подробную информацию о номере документа"
                />
              </button>
            </div>
          </template>
          <template #errorMessage>
            {{ validations.document.series.$errors[0].$message }}
          </template>
          <template #clearButton>
            <FreeCloseButton class="clear-input-button" />
          </template>
        </FreeInput>
        <p class="text-text-neutral-quaternary text-xs">
          {{ t('series.hint') }}
        </p>
      </div>
      <FreeInput
        v-if="providerClassLib.isFunSun(providerClass)"
        v-maska:[inputsMasks.date]
        type="tel"
        :model-value="passenger.document.givenAt"
        :label="t('givenAt')"
        :has-error="validations.document.givenAt.$error"
        :placeholder="t('datePlaceholder')"
        @maska="updateDocument({ givenAt: $event.detail.masked })"
      >
        <template #errorMessage>
          {{ validations.document.givenAt.$errors[0].$message }}
        </template>
        <template #clearButton>
          <FreeCloseButton class="clear-input-button" />
        </template>
      </FreeInput>
      <div class="space-y-3">
        <FreeInput
          v-maska:[inputsMasks.date]
          type="tel"
          :model-value="passenger.document.expiresAt"
          :label="t('document.expirationDate')"
          :has-error="validations.document.expiresAt.$error"
          :placeholder="t('datePlaceholder')"
          @maska="updateDocument({ expiresAt: $event.detail.masked })"
        >
          <template #errorMessage>
            {{ validations.document.expiresAt.$errors[0].$message }}
          </template>
          <template #clearButton>
            <FreeCloseButton class="clear-input-button" />
          </template>
        </FreeInput>
        <p
          v-if="!isDomestic && isKzCitizen"
          class="text-text-neutral-quaternary text-xs"
        >
          {{ t('document.expirationDateInternationalHint') }}
        </p>
      </div>

      <FreeInput
        v-if="providerClassLib.isFunSun(providerClass)"
        v-maska:[inputsMasks.initials]
        :model-value="passenger.document.organization"
        :label="t('organization.label')"
        :has-error="validations.document.organization.$error"
        :placeholder="t('organization.placeholder')"
        @maska="updateDocument({ organization: $event.detail.masked })"
      >
        <template #errorMessage>
          {{ validations.document.organization.$errors[0].$message }}
        </template>
        <template #clearButton>
          <FreeCloseButton class="clear-input-button" />
        </template>
      </FreeInput>
    </div>
    <CitizenshipBottomSheet
      class="top-auto h-screen"
      :name="citizenshipBottomSheetName"
      :selected-country-code="passenger.citizenship"
      :country-codes="countryCodes"
      :is-search-input-visible="isCitizenshipSearchInputVisible"
      :is-popular-countries-visible="isPopularCountriesVisible"
      @onCitizenshipSelect="handleCitizenshipSelect"
    />
    <DocumentsBottomSheet :name="documentsBottomSheetName" />
    <DocumentSeriesBottomSheet :name="documentSeriesBottomSheetName" />
  </section>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { v4 as uuid } from 'uuid';
  import type { Passenger } from '@aviata/booking-data';
  import { controllerModel, citizenshipEntity, providerClassLib } from 'shared';
  import type { Validation } from '@vuelidate/core';
  import type { passengerValidation } from 'shared';

  import {
    FreeInput,
    FreeSegment,
    FreeCloseButton,
    FreeSegmentControl,
  } from '../../../shared/ui';
  import { aviaMasksOptions } from '../../../shared/config';
  import { CitizenshipBottomSheet } from '../../../entities/citizenship-bottom-sheet';
  import { DocumentsBottomSheet } from '../../../entities/documents-bottom-sheet';
  import { DocumentSeriesBottomSheet } from '../../../entities/document-series-bottom-sheet';

  const props = defineProps<{
    sourcePage?: string;
    passenger: Passenger;
    isDomestic: boolean;
    validations: Validation<passengerValidation.types.PassengerValidation>;
    isCitizenshipSearchInputVisible?: boolean;
    isPopularCountriesVisible?: boolean;
    countryCodes?: string[];
    providerClass?: string;
  }>();

  const emit = defineEmits<{
    onPassengerUpdate: [updatedPassenger: Passenger];
  }>();

  const { t } = useI18n();
  const bottomSheet = controllerModel.useBottomSheet();
  const citizenshipBottomSheetName = `citizenship-bottom-sheet-${uuid()}`;
  const documentsBottomSheetName = `documents-bottom-sheet-${uuid()}`;
  const documentSeriesBottomSheetName = `document-series-bottom-sheet`;

  /**
   * Options must be assigned inside the script where it's used.
   * @see https://github.com/beholdr/maska/issues/149#issuecomment-1529619595
   * */
  const inputsMasks = aviaMasksOptions;

  const documentNumberI18nBase = props.isDomestic
    ? 'document.number.domestic'
    : 'document.number.international';

  const citizenshipText = computed(() =>
    citizenshipEntity.lib.getCountryNameByCode(props.passenger.citizenship),
  );
  const isKzCitizen = computed(
    () =>
      props.passenger.citizenship === citizenshipEntity.config.KAZAKHSTAN_CODE,
  );
  const isIinVisible = computed(
    () =>
      props.passenger.citizenship === citizenshipEntity.config.KAZAKHSTAN_CODE,
  );
  const isFinVisible = computed(
    () =>
      props.passenger.citizenship === citizenshipEntity.config.AZERBAIJAN_CODE,
  );

  const isSeriesVisible = computed(
    () =>
      !citizenshipEntity.config.countriesWithoutSeries.includes(
        props.passenger.citizenship,
      ),
  );

  const updatePassenger = (updatedPassenger: Partial<Passenger>) => {
    emit('onPassengerUpdate', { ...props.passenger, ...updatedPassenger });
  };
  const updateDocument = (updatedDocument: Partial<Passenger['document']>) => {
    updatePassenger({
      document: {
        ...props.passenger.document,
        ...updatedDocument,
      },
    });
  };

  const openCitizenshipBottomSheet = () =>
    bottomSheet.show(citizenshipBottomSheetName);
  const handleCitizenshipSelect = (citizenship: string) =>
    updatePassenger({ citizenship });
  const openDocumentsBottomSheet = () =>
    bottomSheet.show(documentsBottomSheetName);
  const openDocumentSeriesBottomSheet = () =>
    bottomSheet.show(documentSeriesBottomSheetName);
</script>

<style scoped>
  .clear-input-button {
    --header-close-button-background-color: theme('colors.gray.400');
    --header-close-button-cross-color: theme('colors.white');
  }
</style>

<i18n src="../locales.json"></i18n>
